// import { FaHandPointer } from "react-icons/fa";
// import { flushSync } from "react-dom";
// import { useNavigate } from "react-router-dom";
// import Frame from "../../assets/images/Frame.png";
// import { FilterContext } from "../../context/Filter";
// import { fetchChildData } from "../CustSearch/apiSearch";
// import Filteraccordion from "../../components/accordion/Filteraccordion";
// import Accordion from "../../components/accordion/Insites";
// import GoldTanstackTable from "./Goldaccdetailstable";
// import Fleetidtable from "./Fleetidtable";
// import Psfaccordian from "./Psfaccordian";
// import BasicModal from "../Modals/BasicModal";
// import mousepointer from "../../assets/images/mouse_hand.png";
// import Infocarddata from "./Infocarddata";
// import arnimage from "../../assets/images/arnphoto.png";
// import {
//   fetchcitycount,
//   fetchcustomerrelationshipage,
//   fetchcitylist,
//   fetchdealertheybuyfrom,
//   fetchvehicle,
//   fetchgetDealerList,
//   fetchtotalfleetid,
//   fetchReferralProspects,
//   fetchgetOptyCount,
//   fetchgetReferralData,
// } from "./Infocardskpi";
// import Infotable1 from "./Infotable1";
// import Infotable2 from "./Infotable2";
// import { useContext, useEffect, useState } from "react";
// import Refferals from "../refferals/Refferals";
// import referalicon from "../../assets/referalicon.png"
// const Filterdata = () => {
//   const {
//     superArn,
//     setSuperArn,
//     arn,
//     setArn,
//     childArn,
//     setChildArn,
//     accountName,
//     setAccountName,
//     isGoldenArn,
//     referralProspects,
//     setReferralProspects,
//   } = useContext(FilterContext);

//   const {
//     datat,
//     setDatat,
//     dealers,
//     setDealers,
//     city,
//     setCity,
//     citylist,
//     setCitylist,
//     age,
//     setAge,
//     dealerslist,
//     setDealerslist,
//     fleetid,
//     setFleetid,
//   } = useContext(FilterContext);

//   const { childData, setChildData } = useContext(FilterContext);
//   const [loading, setLoading] = useState(false);
//   // const [selectedArn, setSelectedArn] = useState(null);
//   const [selectedArn, setSelectedArn] = useState(null);

//   const [isAccordionOpen, setIsAccordionOpen] = useState(true);
//   const [optyCount, setOptyCount] = useState(null);
//   const [refferalData, setRefferalData] = useState(null);

//   const navigate = useNavigate();

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isModalOpen1, setIsModalOpen1] = useState(false);
//   const [isModalOpen2, setIsModalOpen2] = useState(false);
//   const [isModalOpen3, setIsModalOpen3] = useState(false);
//   const [refferalModal, setRefferalModal] = useState(false);

//   // ----Reffereal Modal Functions-----//
//   const handleOpenRefferalModal = () => {
//     setRefferalModal(true);
//   };

//   const handleCloseRefferalModal = () => {
//     setRefferalModal(false);
//   };

//   // ---------- Restore from localStorage on mount ----------
//   useEffect(() => {
//     const storedArn = localStorage.getItem("arn");
//     const storedChildArn = localStorage.getItem("childArn");
//     const storedAccountName = localStorage.getItem("accountName");

//     flushSync(() => {
//       setArn(storedArn ?? "");
//       setChildArn(storedChildArn ?? null);
//       setAccountName(storedAccountName ?? "");
//     });
//   }, []);

//   // ------Reffereal-------//
//   const fetchReferralProspectsData = async (payloadParam) => {
//     try {
//       const payload =
//         payloadParam || (childArn ? { childArn } : { parArn: superArn });
//       const result = await fetchReferralProspects(payload);
//       // console.log('---------------', result);
//       setReferralProspects(result);
//     } catch (error) {
//       console.error("Error fetching dealer list:", error);
//     }
//   };

//   const fetchReferralData = async (payloadParam) => {
//     try {
//       const result = await fetchgetReferralData(payloadParam);
//       setRefferalData(Array.isArray(result) ? result : []); // force array
//     } catch (error) {
//       console.error("Error fetching referral data:", error);
//       setRefferalData([]); // fallback
//     }
//   };

//   const fetchOptyCount = async (payloadParam) => {
//     try {
//       const result = await fetchgetOptyCount(payloadParam);
//       setOptyCount(Array.isArray(result) ? result : []); // force array
//     } catch (error) {
//       console.error("Error fetching opportunity count:", error);
//       setOptyCount([]); // fallback
//     }
//   };

//   // ---------- Fetch functions ----------
//   const fetchtotalvehicledata = async (payloadParam) => {
//     try {
//       const payload =
//         payloadParam || (childArn ? { childArn } : { parArn: superArn });
//       const result = await fetchvehicle(payload);
//       setDatat(result?.doc_count);
//     } catch (error) {
//       console.error("Error fetching vehicle data:", error);
//     }
//   };

//   const fetchtotalfleetids = async (payloadParam) => {
//     try {
//       const payload =
//         payloadParam || (childArn ? { childArn } : { parArn: superArn });
//       const result = await fetchtotalfleetid(payload);
//       setFleetid(result?.value);
//     } catch (error) {
//       console.error("Error fetching fleet id:", error);
//     }
//   };

//   const fetchcityList = async (payloadParam) => {
//     try {
//       const payload =
//         payloadParam || (childArn ? { childArn } : { parArn: superArn });
//       const result = await fetchcitylist(payload);
//       setCitylist(result);
//     } catch (error) {
//       console.error("Error fetching city list:", error);
//     }
//   };

//   const fetchcitycount1 = async (payloadParam) => {
//     try {
//       const payload =
//         payloadParam || (childArn ? { childArn } : { parArn: superArn });
//       const result = await fetchcitycount(payload);
//       setCity(result?.value);
//     } catch (error) {
//       console.error("Error fetching city count:", error);
//     }
//   };

//   const fetchdealers = async (payloadParam) => {
//     try {
//       const payload =
//         payloadParam || (childArn ? { childArn } : { parArn: superArn });
//       const result = await fetchdealertheybuyfrom(payload);
//       setDealers(result?.unique_dealer_count?.value);
//     } catch (error) {
//       console.error("Error fetching dealers:", error);
//     }
//   };

//   const fetchcustomerrltn = async (payloadParam) => {
//     try {
//       const payload =
//         payloadParam || (childArn ? { childArn } : { parArn: superArn });
//       const result = await fetchcustomerrelationshipage(payload);
//       setAge(result?.fields?.years_months_since_first_sale[0]);
//     } catch (error) {
//       console.error("Error fetching customer relationship:", error);
//     }
//   };

//   const fetchgetDealerListt = async (payloadParam) => {
//     try {
//       const payload =
//         payloadParam || (childArn ? { childArn } : { parArn: superArn });
//       const result = await fetchgetDealerList(payload);
//       setDealerslist(result);
//     } catch (error) {
//       console.error("Error fetching dealer list:", error);
//     }
//   };

//   // ---------- Initial Child Data Fetch ----------
//   useEffect(() => {
//     // const getChildData = async (superArn) => {
//     //   setLoading(true);
//     //   try {
//     //     const data = await fetchChildData(superArn);
//     //     setChildData(data);

//     //     // Set selectedArn to parent ARN initially
//     //     setSelectedArn({
//     //       _source: {
//     //         ACCNT_ARN: superArn,
//     //         ACCNT_NAME: accountName,
//     //         PAR_ACCNT_MAIN_PH_NUM: data[0]?._source?.PAR_ACCNT_MAIN_PH_NUM,
//     //         ACCNT_LOCATION: data[0]?._source?.ACCNT_LOCATION,
//     //       },
//     //     });
//     //     setChildArn(null);
//     //   } catch (error) {
//     //     console.error("Error fetching child data:", error);
//     //     setSelectedArn({
//     //       _source: {
//     //         ACCNT_ARN: superArn,
//     //         ACCNT_NAME: accountName,
//     //       },
//     //     });
//     //     setChildArn(null);
//     //   } finally {
//     //     setLoading(false);
//     //   }
//     // };

//     const getChildData = async (superArn) => {
//       const data = await fetchChildData(superArn);
//       setChildData(data);

//       // ✅ don’t auto-select anything
//       setSelectedArn(null);
//       setChildArn(null);
//     };


//     if (superArn) getChildData(superArn);
//   }, [superArn, accountName]);

//   // ---------- Fetch metrics when parent ARN loads (initial fetch) ----------
//   useEffect(() => {
//     if (superArn && !childArn) {
//       const parentPayload = { parArn: superArn };
//       fetchtotalfleetids(parentPayload);
//       fetchcitycount1(parentPayload);
//       fetchcityList(parentPayload);
//       fetchdealers(parentPayload);
//       fetchgetDealerListt(parentPayload);
//       fetchcustomerrltn(parentPayload);
//       fetchtotalvehicledata(parentPayload);
//       fetchReferralProspectsData();
//       fetchOptyCount(parentPayload);
//       fetchReferralData(parentPayload);

//     }
//   }, [superArn]);

//   useEffect(() => {
//     if (selectedArn?._source?.ACCNT_ARN) {
//       const selectedPayload = { childArn: selectedArn._source.ACCNT_ARN };

//       // setChildArn(selectedArn._source.ACCNT_ARN);

//       fetchtotalfleetids(selectedPayload);
//       fetchcitycount1(selectedPayload);
//       fetchcityList(selectedPayload);
//       fetchdealers(selectedPayload);
//       fetchgetDealerListt(selectedPayload);
//       fetchcustomerrltn(selectedPayload);
//       fetchtotalvehicledata(selectedPayload);
//       fetchReferralProspectsData(selectedPayload);
//       fetchOptyCount(selectedPayload);
//       fetchReferralData(selectedPayload);
//       // Persist selected child ARN
//       localStorage.setItem("childArn", selectedArn._source.ACCNT_ARN);
//       localStorage.setItem("accountName", selectedArn._source.ACCNT_NAME || "");
//     }
//   }, [selectedArn]);
//   // console.log("referralProspects", referralProspects);


//   // Choose which ARN to show in the right-hand details block
//   const activeArn = selectedArn
//     ? selectedArn
//     : {
//       _source: {
//         ACCNT_ARN: superArn,
//         ACCNT_NAME: accountName,
//         PAR_ACCNT_MAIN_PH_NUM: childData[0]?._source?.PAR_ACCNT_MAIN_PH_NUM || "",
//         ACCNT_LOCATION: childData[0]?._source?.ACCNT_LOCATION || "",
//       },
//     };


//   // console.log("parr", parArn)


//   return (
//     <>
//       {/* Header */}
//       <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 p-4">
//         {/* LEFT: Golden ARN */}
//         <div className="lg:col-span-3 shadow-sm">
//           <div className="bg-gradient-to-r from-[#2374BF] to-[#2F86C5] rounded-xl shadow-lg text-white relative overflow-hidden min-h-[360px]">
//             <div className="flex justify-center pt-8 pb-4">
//               <img src={arnimage} className="h-20" />
//             </div>

//             <div className="px-6 text-center">
//               <h2 className="text-xl font-bold mb-1">Golden ARN</h2>
//               <p className="text-sm">{superArn}</p>
//               <hr className="my-2 border-t border-gray-300" />

//               <BasicModal
//                 open={isModalOpen}
//                 handleOpenModal={() => setIsModalOpen(true)}
//                 handleCloseModal={() => setIsModalOpen(false)}
//                 title={"Golden Account Details"}
//                 trigger={
//                   <button
//                     className="block w-full text-sm text-center animate-pulse py-1 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
//                     onClick={() => setIsModalOpen(true)}
//                   >
//                     {accountName}
//                   </button>
//                 }
//               >
//                 <GoldTanstackTable />
//               </BasicModal>
//               <div className=" text-sm">
//                 {isGoldenArn
//                   ? (() => {
//                     const maskedPhone = childData[0]?._source
//                       ?.PAR_ACCNT_MAIN_PH_NUM
//                       ? `${childData[0]._source.PAR_ACCNT_MAIN_PH_NUM.slice(
//                         0,
//                         2
//                       )}******${childData[0]._source.PAR_ACCNT_MAIN_PH_NUM.slice(
//                         -2
//                       )}`
//                       : "XXXXXXX";
//                     return <p className="mb-2"> {maskedPhone}</p>;
//                   })()
//                   : (() => {
//                     const maskedPhone = childData[0]?._source
//                       ?.ACCNT_MAIN_PH_NUM
//                       ? `${childData[0]._source.ACCNT_MAIN_PH_NUM.slice(
//                         0,
//                         2
//                       )}******${childData[0]._source.ACCNT_MAIN_PH_NUM.slice(
//                         -2
//                       )}`
//                       : "XXXXXXX";
//                     return <p className="mb-2"> {maskedPhone}</p>;
//                   })()}

//                 {(() => {
//                   const accntLocation = childData?.[0]?._source?.ACCNT_LOCATION;

//                   const maskedLocation =
//                     typeof accntLocation === "string" &&
//                       accntLocation.startsWith("KA-")
//                       ? accntLocation
//                       : childData?.[0]
//                         ? "XXXXXXXXX"
//                         : "-----";

//                   return <p className="mb-2">{maskedLocation}</p>;
//                 })()}
//               </div>

//               <div className="bg-gradient-to-r from-[#1545C0] to-[#2B3D6B] bg-opacity-50 rounded-full py-1 px-4 mt-2 mb-8">
//                 <span className="text-sm font-medium">
//                   Total Child: {childData.length}
//                 </span>
//                 <div className="justify-center justify-items-center">
//                   <button
//                     onClick={() => {
//                       flushSync(() => {
//                         setArn(superArn);
//                         setChildArn(null);
//                         setAccountName("");
//                         localStorage.setItem("arn", superArn);
//                         localStorage.removeItem("childArn");
//                         localStorage.removeItem("accountName");
//                       });
//                       navigate("/piplineAndService");
//                     }}
//                     className="absolute transform bg-blue-800 animate-pulse bg-opacity-50 text-white px-6 py-1 mt-3 rounded-full shadow-lg hover:bg-opacity-70 flex items-center gap-2 transition-all"
//                     title="Click Here"
//                   >
//                     <FaHandPointer className="text-lg mt-1 mb-1" />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* MIDDLE: Child ARN list */}
//         <div className="lg:col-span-5 rounded-lg shadow-lg">
//           <div className="bg-white rounded-lg shadow-sm">
//             <div className="px-6 py-2">
//               <div className="flex justify-between items-center">
//                 {/* Left side: Child ARNs */}
//                 <h2 className="text-lg font-semibold text-gray-700">
//                   Child ARNs ({childData.length})
//                 </h2>

//                 {/* Right side: FilterAccordion */}
//                 <div>
//                   <Filteraccordion />
//                 </div>
//               </div>
//               {/* <h2 className="text-lg font-semibold text-gray-700">
//                 Child ARNs ({childData.length})
//               </h2> */}
//             </div>

//             <div className="max-h-[312px] overflow-y-auto">
//               {loading ? (
//                 <div className="flex justify-center items-center py-6">
//                   <div className="animate-spin rounded-full h-9 w-8 border-b-2 border-blue-600"></div>
//                 </div>
//               ) : childData.length > 0 ? (
//                 childData.map((item, index) => {
//                   const isSelected =
//                     selectedArn?._source?.ACCNT_ARN === item._source.ACCNT_ARN;
//                   const accountLocation =
//                     item._source.ACCNT_LOCATION?.startsWith("KA-")
//                       ? item._source.ACCNT_LOCATION
//                       : "XXXXXXXXX";

//                   return (
//                     <div
//                       key={index}
//                       className={`border-b border-gray-100 px-6 py-3 hover:bg-gray-50 cursor-pointer ${isSelected ? "bg-blue-100" : ""
//                         }`}
//                       onClick={() => {
//                         // Select child ARN when clicked
//                         setSelectedArn(item);
//                       }}
//                     >
//                       <div className="flex justify-between items-center">
//                         <div className="flex-1 bg-[#F1F5F9] rounded-lg border border-[#D0D0D0] p-2">
//                           <div className="flex justify-between items-start mb-1">
//                             <span className="text-sm font-medium">
//                               ARN: {item._source.ACCNT_ARN}
//                             </span>

//                             <button
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 flushSync(() => {
//                                   setChildArn(item._source.ACCNT_ARN);
//                                   setArn(null);
//                                   setAccountName(
//                                     item?._source?.ACCNT_NAME || ""
//                                   );
//                                   localStorage.setItem(
//                                     "childArn",
//                                     item._source.ACCNT_ARN
//                                   );
//                                   localStorage.setItem(
//                                     "accountName",
//                                     item._source.ACCNT_NAME || ""
//                                   );
//                                   localStorage.removeItem("arn");
//                                 });
//                                 navigate("/piplineAndService");
//                               }}
//                             >
//                               ➡️
//                             </button>
//                           </div>
//                           <div className="flex justify-between">
//                             <span className="text-sm text-gray-600">
//                               Account Name:
//                             </span>
//                             <span className="text-sm">
//                               {item._source.ACCNT_NAME || "N/A"}
//                             </span>
//                           </div>
//                           <div className="flex justify-between">
//                             <span className="text-sm text-gray-600">
//                               KA Code:
//                             </span>
//                             <span className="text-sm">
//                               {item._source.ACCNT_LOCATION || "N/A"}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })
//               ) : (
//                 <div className="text-center py-8 text-gray-500">
//                   No Data Found
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* RIGHT: Selected ARN Details */}
//         <div className="lg:col-span-4 ">
//           <div className="bg-white rounded-lg shadow-lg">
//             <div className="border-b border-gray-200 px-2 py-1 shadow-lg">
//               <h2 className="text-lg font-semibold text-gray-500">
//                 Selected ARN Details
//               </h2>
//             </div>

//             <div className="p-1 overflow-y-auto max-h-[320px] h-full">
//               {activeArn ? (
//                 <div className="">
//                   {/* ARN */}
//                   <div className="flex items-center shadow-md border p-2 justify-between">
//                     <span className="text-gray-600 text-[14px] font-medium">
//                       🆔 ARN
//                     </span>
//                     <span className="font-medium text-gray-900 text-[14px]">
//                       {activeArn._source.ACCNT_ARN}
//                     </span>
//                   </div>

//                   {/* Phone */}
//                   {activeArn._source.ACCNT_ARN === superArn
//                     ? (() => {
//                       const phone =
//                         activeArn?._source?.PAR_ACCNT_MAIN_PH_NUM;
//                       const maskedPhone = phone
//                         ? `${phone.slice(0, 2)}******${phone.slice(-2)}`
//                         : "XXXXXXX";
//                       return (
//                         <div className="flex items-center shadow-md p-3 justify-between border-b border-gray-100">
//                           <span className="text-gray-600 text-[14px]">
//                             📱Mobile
//                           </span>
//                           <span className="font-medium text-gray-900 text-[14px]">
//                             {maskedPhone}
//                           </span>
//                         </div>
//                       );
//                     })()
//                     : (() => {
//                       const phone = selectedArn?._source?.ACCNT_MAIN_PH_NUM;
//                       const maskedPhone = phone
//                         ? `${phone.slice(0, 2)}******${phone.slice(-2)}`
//                         : "XXXXXXX";
//                       return (
//                         <div className="flex items-center shadow-md p-3 justify-between border-b border-gray-100">
//                           <span className="text-gray-600 text-[14px]">
//                             📱Mobile
//                           </span>
//                           <span className="font-medium text-gray-900 text-[14px]">
//                             {maskedPhone}
//                           </span>
//                         </div>
//                       );
//                     })()}

//                   {/* Fleet ID */}
//                   <div className="flex items-center shadow-md p-1 justify-between border-b border-gray-100">
//                     <span className="text-gray-600 text-[14px]">
//                       {" "}
//                       🔑 Fleet ID
//                     </span>
//                     <div className="flex items-center gap-1">
//                       <span className="font-medium text-[14px] text-gray-900">
//                         {fleetid}
//                       </span>
//                       <BasicModal
//                         open={isModalOpen1}
//                         handleOpenModal={() => setIsModalOpen1(true)}
//                         handleCloseModal={() => setIsModalOpen1(false)}
//                         title={"Fleet Details"}
//                         trigger={
//                           <button
//                             className="block w-full text-sm text-center animate-pulse py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
//                             onClick={() => setIsModalOpen1(true)}
//                           >
//                             <img src={mousepointer} />
//                           </button>
//                         }
//                       >
//                         <Fleetidtable />
//                       </BasicModal>
//                     </div>
//                   </div>

//                   {/* Vehicles */}
//                   <div className="flex items-center shadow-md p-3 justify-between border-b border-gray-100">
//                     <span className="text-gray-600 text-[14px]">
//                       🚚 Total Vehicles
//                     </span>
//                     <span className="font-medium text-gray-900 text-[14px]">
//                       {datat}
//                     </span>
//                   </div>

//                   {/* Age */}
//                   <div className="flex items-center shadow-md p-3 justify-between border-b border-gray-100">
//                     <span className="text-gray-600 text-[14px]">
//                       🕰️ Relationship Age
//                     </span>
//                     <span className="font-medium text-gray-900 text-[14px]">
//                       {age}
//                     </span>
//                   </div>

//                   {/* Dealers */}
//                   <div className="flex items-center shadow-md p-2 justify-between border-b border-gray-100">
//                     <span className="text-gray-600 text-[14px]">
//                       🤝 Dealers They Buy From
//                     </span>
//                     <div className="flex items-center gap-2">
//                       <span className="font-medium text-gray-900 text-[14px]">
//                         {dealers}
//                       </span>
//                       <BasicModal
//                         open={isModalOpen3}
//                         handleOpenModal={() => setIsModalOpen3(true)}
//                         handleCloseModal={() => setIsModalOpen3(false)}
//                         title={"Dealer"}
//                         trigger={
//                           <button
//                             className="block w-full text-sm text-center animate-pulse py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
//                             onClick={() => setIsModalOpen3(true)}
//                           >
//                             <img src={mousepointer} />
//                           </button>
//                         }
//                       >
//                         <Infotable1 data={dealerslist} />
//                       </BasicModal>
//                     </div>
//                   </div>

//                   {/* Cities */}
//                   <div className="flex items-center shadow-md p-2 justify-between">
//                     <span className="text-gray-600 text-[14px]">
//                       🏙️ City They Operate In
//                     </span>
//                     <div className="flex items-center gap-2">
//                       <span className="font-medium text-gray-900 text-[14px]">
//                         {city}
//                       </span>
//                       <BasicModal
//                         open={isModalOpen2}
//                         handleOpenModal={() => setIsModalOpen2(true)}
//                         handleCloseModal={() => setIsModalOpen2(false)}
//                         title={"City"}
//                         trigger={
//                           <button
//                             className="block w-full text-sm text-center animate-pulse py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
//                             onClick={() => setIsModalOpen2(true)}
//                           >
//                             <img src={mousepointer} />
//                           </button>
//                         }
//                       >
//                         <Infotable2 data={citylist} />
//                       </BasicModal>
//                     </div>
//                   </div>
//                   <div className="flex items-center shadow-md p-2 justify-between">
//                     <span className="text-gray-600 text-[14px] flex gap-2">
//                       <img src={referalicon} />
//                       Referrals
//                     </span>
//                     <div className="flex items-center gap-2">
//                       <span className="font-medium text-gray-900 text-[14px]">
//                         {typeof referralProspects === "object"
//                           ? referralProspects?.count ?? 0
//                           : referralProspects ?? 0}
//                       </span>
//                       <BasicModal
//                         open={refferalModal}
//                         handleOpenModal={handleOpenRefferalModal}
//                         handleCloseModal={handleCloseRefferalModal}
//                         title={"Referrals"}
//                         trigger={
//                           <button
//                             className="block w-full text-sm text-center animate-pulse py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
//                             onClick={handleOpenRefferalModal}
//                           >
//                             <img src={mousepointer} />
//                           </button>
//                         }
//                       >
//                         <Refferals
//                           refferalsDataGraph={
//                             Array.isArray(refferalData) ? refferalData : []
//                           }
//                           refferalsOptyGraph={
//                             Array.isArray(optyCount) ? optyCount : []
//                           }
//                         />
//                       </BasicModal>
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div className="text-center py-8 text-gray-500">
//                   No ARN Selected
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Accordion Section */}
//       <Accordion
//         isOpen={isAccordionOpen}
//         onToggle={() => setIsAccordionOpen((prev) => !prev)}
//       />
//       <Infocarddata />
//     </>
//   );
// };

// export default Filterdata;


import { FaHandPointer } from "react-icons/fa";
import { flushSync } from "react-dom";
import { useNavigate } from "react-router-dom";
import Frame from "../../assets/images/Frame.png";
import { FilterContext } from "../../context/Filter";
import { fetchChildData } from "../CustSearch/apiSearch";
import Filteraccordion from "../../components/accordion/Filteraccordion";
import Accordion from "../../components/accordion/Insites";
import GoldTanstackTable from "./Goldaccdetailstable";
import Fleetidtable from "./Fleetidtable";
import Psfaccordian from "./Psfaccordian";
import BasicModal from "../Modals/BasicModal";
import mousepointer from "../../assets/images/mouse_hand.png";
import Infocarddata from "./Infocarddata";
import arnimage from "../../assets/images/arnphoto.png";
import {
  fetchcitycount,
  fetchcustomerrelationshipage,
  fetchcitylist,
  fetchdealertheybuyfrom,
  fetchvehicle,
  fetchgetDealerList,
  fetchtotalfleetid,
  fetchReferralProspects,
  fetchgetOptyCount,
  fetchgetReferralData,
} from "./Infocardskpi";
import Infotable1 from "./Infotable1";
import Infotable2 from "./Infotable2";
import { useContext, useEffect, useState } from "react";
import Refferals from "../refferals/Refferals";
import referalicon from "../../assets/referalicon.png"
const Filterdata = () => {
  const {
    superArn,
    setSuperArn,
    arn,
    setArn,
    childArn,
    setChildArn,
    accountName,
    setAccountName,
    isGoldenArn,
    referralProspects,
    setReferralProspects,
  } = useContext(FilterContext);

  const {
    datat,
    setDatat,
    dealers,
    setDealers,
    city,
    setCity,
    citylist,
    setCitylist,
    age,
    setAge,
    dealerslist,
    setDealerslist,
    fleetid,
    setFleetid,
  } = useContext(FilterContext);

  const { childData, setChildData } = useContext(FilterContext);
  const [loading, setLoading] = useState(false);
  // const [selectedArn, setSelectedArn] = useState(null);
  const [selectedArn, setSelectedArn] = useState(null);

  const [isAccordionOpen, setIsAccordionOpen] = useState(true);
  const [optyCount, setOptyCount] = useState(null);
  const [refferalData, setRefferalData] = useState(null);

  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [refferalModal, setRefferalModal] = useState(false);

  // ----Reffereal Modal Functions-----//
  const handleOpenRefferalModal = () => {
    setRefferalModal(true);
  };

  const handleCloseRefferalModal = () => {
    setRefferalModal(false);
  };

  // ---------- Restore from localStorage on mount ----------
  useEffect(() => {
    const storedArn = localStorage.getItem("arn");
    const storedChildArn = localStorage.getItem("childArn");
    const storedAccountName = localStorage.getItem("accountName");

    flushSync(() => {
      setArn(storedArn ?? "");
      setChildArn(storedChildArn ?? null);
      setAccountName(storedAccountName ?? "");
    });
  }, []);

  // ------Reffereal-------//
  const fetchReferralProspectsData = async (payloadParam) => {
    try {
      const payload =
        payloadParam || (childArn ? { childArn } : { parArn: superArn });
      const result = await fetchReferralProspects(payload);
      // console.log('---------------', result);
      setReferralProspects(result);
    } catch (error) {
      console.error("Error fetching dealer list:", error);
    }
  };

  const fetchReferralData = async (payloadParam) => {
    try {
      const result = await fetchgetReferralData(payloadParam);
      setRefferalData(Array.isArray(result) ? result : []); // force array
    } catch (error) {
      console.error("Error fetching referral data:", error);
      setRefferalData([]); // fallback
    }
  };

  const fetchOptyCount = async (payloadParam) => {
    try {
      const result = await fetchgetOptyCount(payloadParam);
      setOptyCount(Array.isArray(result) ? result : []); // force array
    } catch (error) {
      console.error("Error fetching opportunity count:", error);
      setOptyCount([]); // fallback
    }
  };

  // ---------- Fetch functions ----------
  const fetchtotalvehicledata = async (payloadParam) => {
    try {
      const payload =
        payloadParam || (childArn ? { childArn } : { parArn: superArn });
      const result = await fetchvehicle(payload);
      setDatat(result?.doc_count);
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
    }
  };

  const fetchtotalfleetids = async (payloadParam) => {
    try {
      const payload =
        payloadParam || (childArn ? { childArn } : { parArn: superArn });
      const result = await fetchtotalfleetid(payload);
      setFleetid(result?.value);
    } catch (error) {
      console.error("Error fetching fleet id:", error);
    }
  };

  const fetchcityList = async (payloadParam) => {
    try {
      const payload =
        payloadParam || (childArn ? { childArn } : { parArn: superArn });
      const result = await fetchcitylist(payload);
      setCitylist(result);
    } catch (error) {
      console.error("Error fetching city list:", error);
    }
  };

  const fetchcitycount1 = async (payloadParam) => {
    try {
      const payload =
        payloadParam || (childArn ? { childArn } : { parArn: superArn });
      const result = await fetchcitycount(payload);
      setCity(result?.value);
    } catch (error) {
      console.error("Error fetching city count:", error);
    }
  };

  const fetchdealers = async (payloadParam) => {
    try {
      const payload =
        payloadParam || (childArn ? { childArn } : { parArn: superArn });
      const result = await fetchdealertheybuyfrom(payload);
      setDealers(result?.unique_dealer_count?.value);
    } catch (error) {
      console.error("Error fetching dealers:", error);
    }
  };

  const fetchcustomerrltn = async (payloadParam) => {
    try {
      const payload =
        payloadParam || (childArn ? { childArn } : { parArn: superArn });
      const result = await fetchcustomerrelationshipage(payload);
      setAge(result?.fields?.years_months_since_first_sale[0]);
    } catch (error) {
      console.error("Error fetching customer relationship:", error);
    }
  };

  const fetchgetDealerListt = async (payloadParam) => {
    try {
      const payload =
        payloadParam || (childArn ? { childArn } : { parArn: superArn });
      const result = await fetchgetDealerList(payload);
      setDealerslist(result);
    } catch (error) {
      console.error("Error fetching dealer list:", error);
    }
  };

  // ---------- Initial Child Data Fetch ----------
  useEffect(() => {
    // const getChildData = async (superArn) => {
    //   setLoading(true);
    //   try {
    //     const data = await fetchChildData(superArn);
    //     setChildData(data);

    //     // Set selectedArn to parent ARN initially
    //     setSelectedArn({
    //       _source: {
    //         ACCNT_ARN: superArn,
    //         ACCNT_NAME: accountName,
    //         PAR_ACCNT_MAIN_PH_NUM: data[0]?._source?.PAR_ACCNT_MAIN_PH_NUM,
    //         ACCNT_LOCATION: data[0]?._source?.ACCNT_LOCATION,
    //       },
    //     });
    //     setChildArn(null);
    //   } catch (error) {
    //     console.error("Error fetching child data:", error);
    //     setSelectedArn({
    //       _source: {
    //         ACCNT_ARN: superArn,
    //         ACCNT_NAME: accountName,
    //       },
    //     });
    //     setChildArn(null);
    //   } finally {
    //     setLoading(false);
    //   }
    // };

    const getChildData = async (superArn) => {
      const data = await fetchChildData(superArn);
      setChildData(data);

      // ✅ don’t auto-select anything
      setSelectedArn(null);
      setChildArn(null);
    };


    if (superArn) getChildData(superArn);
  }, [superArn, accountName]);

  // ---------- Fetch metrics when parent ARN loads (initial fetch) ----------
  useEffect(() => {
    if (superArn && !childArn) {
      const parentPayload = { parArn: superArn };
      fetchtotalfleetids(parentPayload);
      fetchcitycount1(parentPayload);
      fetchcityList(parentPayload);
      fetchdealers(parentPayload);
      fetchgetDealerListt(parentPayload);
      fetchcustomerrltn(parentPayload);
      fetchtotalvehicledata(parentPayload);
      fetchReferralProspectsData();
      fetchOptyCount(parentPayload);
      fetchReferralData(parentPayload);

    }
  }, [superArn]);

  useEffect(() => {
    if (selectedArn?._source?.ACCNT_ARN) {
      const selectedPayload = { childArn: selectedArn._source.ACCNT_ARN };

      // setChildArn(selectedArn._source.ACCNT_ARN);

      fetchtotalfleetids(selectedPayload);
      fetchcitycount1(selectedPayload);
      fetchcityList(selectedPayload);
      fetchdealers(selectedPayload);
      fetchgetDealerListt(selectedPayload);
      fetchcustomerrltn(selectedPayload);
      fetchtotalvehicledata(selectedPayload);
      fetchReferralProspectsData(selectedPayload);
      fetchOptyCount(selectedPayload);
      fetchReferralData(selectedPayload);
      // Persist selected child ARN
      localStorage.setItem("childArn", selectedArn._source.ACCNT_ARN);
      localStorage.setItem("accountName", selectedArn._source.ACCNT_NAME || "");
    }
  }, [selectedArn]);
  // console.log("referralProspects", referralProspects);


  // Choose which ARN to show in the right-hand details block
  const activeArn = selectedArn
    ? selectedArn
    : {
      _source: {
        ACCNT_ARN: superArn,
        ACCNT_NAME: accountName,
        PAR_ACCNT_MAIN_PH_NUM: childData[0]?._source?.PAR_ACCNT_MAIN_PH_NUM || "",
        ACCNT_LOCATION: childData[0]?._source?.ACCNT_LOCATION || "",
      },
    };


  // console.log("parr", parArn)


  return (
    <>
      {/* Header */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 p-4">
        {/* LEFT: Golden ARN */}
        <div className="lg:col-span-3 shadow-sm">
          <div className="bg-gradient-to-r from-[#2374BF] to-[#2F86C5] rounded-xl shadow-lg text-white relative overflow-hidden min-h-[360px]">
            <div className="flex justify-center pt-8 pb-4">
              <img src={arnimage} className="h-20" />
            </div>

            <div className="px-6 text-center">
              <h2 className="text-xl font-bold mb-1">Golden ARN</h2>
              <p className="text-sm">{superArn}</p>
              <hr className="my-2 border-t border-gray-300" />

              <BasicModal
                open={isModalOpen}
                handleOpenModal={() => setIsModalOpen(true)}
                handleCloseModal={() => setIsModalOpen(false)}
                title={"Golden Account Details"}
                trigger={
                  <button
                    className="block w-full text-sm text-center animate-pulse py-1 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                    onClick={() => setIsModalOpen(true)}
                  >
                    {accountName}
                  </button>
                }
              >
                <GoldTanstackTable />
              </BasicModal>
              <div className=" text-sm">
                {isGoldenArn
                  ? (() => {
                    const maskedPhone = childData[0]?._source
                      ?.PAR_ACCNT_MAIN_PH_NUM
                      ? `${childData[0]._source.PAR_ACCNT_MAIN_PH_NUM.slice(
                        0,
                        2
                      )}******${childData[0]._source.PAR_ACCNT_MAIN_PH_NUM.slice(
                        -2
                      )}`
                      : "XXXXXXX";
                    return <p className="mb-2"> {maskedPhone}</p>;
                  })()
                  : (() => {
                    const maskedPhone = childData[0]?._source
                      ?.ACCNT_MAIN_PH_NUM
                      ? `${childData[0]._source.ACCNT_MAIN_PH_NUM.slice(
                        0,
                        2
                      )}******${childData[0]._source.ACCNT_MAIN_PH_NUM.slice(
                        -2
                      )}`
                      : "XXXXXXX";
                    return <p className="mb-2"> {maskedPhone}</p>;
                  })()}

                {(() => {
                  const accntLocation = childData?.[0]?._source?.ACCNT_LOCATION;

                  const maskedLocation =
                    typeof accntLocation === "string" &&
                      accntLocation.startsWith("KA-")
                      ? accntLocation
                      : childData?.[0]
                        ? "XXXXXXXXX"
                        : "-----";

                  return <p className="mb-2">{maskedLocation}</p>;
                })()}
              </div>

              <div className="bg-gradient-to-r from-[#1545C0] to-[#2B3D6B] bg-opacity-50 rounded-full py-1 px-4 mt-2 mb-8">
                <span className="text-sm font-medium">
                  Total Child: {childData.length}
                </span>
                <div className="justify-center justify-items-center">
                  {/* <button
                    onClick={() => {
                      flushSync(() => {
                        setArn(superArn);
                        setChildArn(null);
                        setAccountName("");
                        localStorage.setItem("arn", superArn);
                        localStorage.removeItem("childArn");
                        localStorage.removeItem("accountName");
                      });
                      navigate("/piplineAndService");
                    }}
                    className="absolute transform bg-blue-800 animate-pulse bg-opacity-50 text-white px-6 py-1 mt-3 rounded-full shadow-lg hover:bg-opacity-70 flex items-center gap-2 transition-all"
                    title="Click Here"
                  > */}

                  <button
                    onClick={() => {
                      flushSync(() => {
                        setArn(superArn);
                        setChildArn(null);
                        setAccountName("");
                        localStorage.setItem("arn", superArn);
                        localStorage.removeItem("childArn");
                        localStorage.removeItem("accountName");
                      });

                      // ✅ Get allowed paths from localStorage
                      const storedPaths = localStorage.getItem("allowedPaths");
                      let allowedPaths = [];

                      try {
                        allowedPaths = storedPaths ? JSON.parse(storedPaths) : [];
                      } catch {
                        allowedPaths = [];
                      }

                      // ✅ Define priority order
                      const priorityOrder = [
                        "/piplineAndService",
                        "/Services",
                        "/complaints",
                        "/fleet-insigths",
                        "/pvin",
                        "/arnenrichment",
                        "/approver"

                      ];

                      // ✅ Find first allowed route
                      const routeToNavigate =
                        priorityOrder.find((route) => allowedPaths.includes(route)) ||
                        "/home"; // fallback

                      navigate(routeToNavigate);
                    }}
                    className="absolute transform bg-blue-800 animate-pulse bg-opacity-50 text-white px-6 py-1 mt-3 rounded-full shadow-lg hover:bg-opacity-70 flex items-center gap-2 transition-all"
                    title="Click Here"
                  >
                    <FaHandPointer className="text-lg mt-1 mb-1" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* MIDDLE: Child ARN list */}
        <div className="lg:col-span-5 rounded-lg shadow-lg">
          <div className="bg-white rounded-lg shadow-sm">
            <div className="px-6 py-2">
              <div className="flex justify-between items-center">
                {/* Left side: Child ARNs */}
                <h2 className="text-lg font-semibold text-gray-700">
                  Child ARNs ({childData.length})
                </h2>

                {/* Right side: FilterAccordion */}
                <div>
                  <Filteraccordion />
                </div>
              </div>
              {/* <h2 className="text-lg font-semibold text-gray-700">
                Child ARNs ({childData.length})
              </h2> */}
            </div>

            <div className="max-h-[312px] overflow-y-auto">
              {loading ? (
                <div className="flex justify-center items-center py-6">
                  <div className="animate-spin rounded-full h-9 w-8 border-b-2 border-blue-600"></div>
                </div>
              ) : childData.length > 0 ? (
                childData.map((item, index) => {
                  const isSelected =
                    selectedArn?._source?.ACCNT_ARN === item._source.ACCNT_ARN;
                  const accountLocation =
                    item._source.ACCNT_LOCATION?.startsWith("KA-")
                      ? item._source.ACCNT_LOCATION
                      : "XXXXXXXXX";

                  return (
                    <div
                      key={index}
                      className={`border-b border-gray-100 px-6 py-3 hover:bg-gray-50 cursor-pointer ${isSelected ? "bg-blue-100" : ""
                        }`}
                      onClick={() => {
                        // Select child ARN when clicked
                        setSelectedArn(item);
                      }}
                    >
                      <div className="flex justify-between items-center">
                        <div className="flex-1 bg-[#F1F5F9] rounded-lg border border-[#D0D0D0] p-2">
                          <div className="flex justify-between items-start mb-1">
                            <span className="text-sm font-medium">
                              ARN: {item._source.ACCNT_ARN}
                            </span>

                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                flushSync(() => {
                                  setChildArn(item._source.ACCNT_ARN);
                                  setArn(null);
                                  setAccountName(
                                    item?._source?.ACCNT_NAME || ""
                                  );
                                  localStorage.setItem(
                                    "childArn",
                                    item._source.ACCNT_ARN
                                  );
                                  localStorage.setItem(
                                    "accountName",
                                    item._source.ACCNT_NAME || ""
                                  );
                                  localStorage.removeItem("arn");
                                });
                                navigate("/piplineAndService");
                              }}
                            >
                              ➡️
                            </button>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-sm text-gray-600">
                              Account Name:
                            </span>
                            <span className="text-sm">
                              {item._source.ACCNT_NAME || "N/A"}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-sm text-gray-600">
                              KA Code:
                            </span>
                            <span className="text-sm">
                              {item._source.ACCNT_LOCATION || "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="text-center py-8 text-gray-500">
                  No Data Found
                </div>
              )}
            </div>
          </div>
        </div>

        {/* RIGHT: Selected ARN Details */}
        <div className="lg:col-span-4 ">
          <div className="bg-white rounded-lg shadow-lg">
            <div className="border-b border-gray-200 px-2 py-1 shadow-lg">
              <h2 className="text-lg font-semibold text-gray-500">
                Selected ARN Details
              </h2>
            </div>

            <div className="p-1 overflow-y-auto max-h-[320px] h-full">
              {activeArn ? (
                <div className="">
                  {/* ARN */}
                  <div className="flex items-center shadow-md border p-2 justify-between">
                    <span className="text-gray-600 text-[14px] font-medium">
                      🆔 ARN
                    </span>
                    <span className="font-medium text-gray-900 text-[14px]">
                      {activeArn._source.ACCNT_ARN}
                    </span>
                  </div>

                  {/* Phone */}
                  {activeArn._source.ACCNT_ARN === superArn
                    ? (() => {
                      const phone =
                        activeArn?._source?.PAR_ACCNT_MAIN_PH_NUM;
                      const maskedPhone = phone
                        ? `${phone.slice(0, 2)}******${phone.slice(-2)}`
                        : "XXXXXXX";
                      return (
                        <div className="flex items-center shadow-md p-3 justify-between border-b border-gray-100">
                          <span className="text-gray-600 text-[14px]">
                            📱Mobile
                          </span>
                          <span className="font-medium text-gray-900 text-[14px]">
                            {maskedPhone}
                          </span>
                        </div>
                      );
                    })()
                    : (() => {
                      const phone = selectedArn?._source?.ACCNT_MAIN_PH_NUM;
                      const maskedPhone = phone
                        ? `${phone.slice(0, 2)}******${phone.slice(-2)}`
                        : "XXXXXXX";
                      return (
                        <div className="flex items-center shadow-md p-3 justify-between border-b border-gray-100">
                          <span className="text-gray-600 text-[14px]">
                            📱Mobile
                          </span>
                          <span className="font-medium text-gray-900 text-[14px]">
                            {maskedPhone}
                          </span>
                        </div>
                      );
                    })()}

                  {/* Fleet ID */}
                  <div className="flex items-center shadow-md p-1 justify-between border-b border-gray-100">
                    <span className="text-gray-600 text-[14px]">
                      {" "}
                      🔑 Fleet ID
                    </span>
                    <div className="flex items-center gap-1">
                      <span className="font-medium text-[14px] text-gray-900">
                        {fleetid}
                      </span>
                      <BasicModal
                        open={isModalOpen1}
                        handleOpenModal={() => setIsModalOpen1(true)}
                        handleCloseModal={() => setIsModalOpen1(false)}
                        title={"Fleet Details"}
                        trigger={
                          <button
                            className="block w-full text-sm text-center animate-pulse py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                            onClick={() => setIsModalOpen1(true)}
                          >
                            <img src={mousepointer} />
                          </button>
                        }
                      >
                        <Fleetidtable />
                      </BasicModal>
                    </div>
                  </div>

                  {/* Vehicles */}
                  <div className="flex items-center shadow-md p-3 justify-between border-b border-gray-100">
                    <span className="text-gray-600 text-[14px]">
                      🚚 Total Vehicles
                    </span>
                    <span className="font-medium text-gray-900 text-[14px]">
                      {datat}
                    </span>
                  </div>

                  {/* Age */}
                  <div className="flex items-center shadow-md p-3 justify-between border-b border-gray-100">
                    <span className="text-gray-600 text-[14px]">
                      🕰️ Relationship Age
                    </span>
                    <span className="font-medium text-gray-900 text-[14px]">
                      {age}
                    </span>
                  </div>

                  {/* Dealers */}
                  <div className="flex items-center shadow-md p-2 justify-between border-b border-gray-100">
                    <span className="text-gray-600 text-[14px]">
                      🤝 Dealers They Buy From
                    </span>
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-gray-900 text-[14px]">
                        {dealers}
                      </span>
                      <BasicModal
                        open={isModalOpen3}
                        handleOpenModal={() => setIsModalOpen3(true)}
                        handleCloseModal={() => setIsModalOpen3(false)}
                        title={"Dealer"}
                        trigger={
                          <button
                            className="block w-full text-sm text-center animate-pulse py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                            onClick={() => setIsModalOpen3(true)}
                          >
                            <img src={mousepointer} />
                          </button>
                        }
                      >
                        <Infotable1 data={dealerslist} />
                      </BasicModal>
                    </div>
                  </div>

                  {/* Cities */}
                  <div className="flex items-center shadow-md p-2 justify-between">
                    <span className="text-gray-600 text-[14px]">
                      🏙️ City They Operate In
                    </span>
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-gray-900 text-[14px]">
                        {city}
                      </span>
                      <BasicModal
                        open={isModalOpen2}
                        handleOpenModal={() => setIsModalOpen2(true)}
                        handleCloseModal={() => setIsModalOpen2(false)}
                        title={"City"}
                        trigger={
                          <button
                            className="block w-full text-sm text-center animate-pulse py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                            onClick={() => setIsModalOpen2(true)}
                          >
                            <img src={mousepointer} />
                          </button>
                        }
                      >
                        <Infotable2 data={citylist} />
                      </BasicModal>
                    </div>
                  </div>
                  <div className="flex items-center shadow-md p-2 justify-between">
                    <span className="text-gray-600 text-[14px] flex gap-2">
                      <img src={referalicon} />
                      Referrals
                    </span>
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-gray-900 text-[14px]">
                        {typeof referralProspects === "object"
                          ? referralProspects?.count ?? 0
                          : referralProspects ?? 0}
                      </span>
                      <BasicModal
                        open={refferalModal}
                        handleOpenModal={handleOpenRefferalModal}
                        handleCloseModal={handleCloseRefferalModal}
                        title={"Referrals"}
                        trigger={
                          <button
                            className="block w-full text-sm text-center animate-pulse py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                            onClick={handleOpenRefferalModal}
                          >
                            <img src={mousepointer} />
                          </button>
                        }
                      >
                        <Refferals
                          refferalsDataGraph={
                            Array.isArray(refferalData) ? refferalData : []
                          }
                          refferalsOptyGraph={
                            Array.isArray(optyCount) ? optyCount : []
                          }
                        />
                      </BasicModal>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center py-8 text-gray-500">
                  No ARN Selected
                </div>
              )}
            </div>
          </div>
        </div>
      </div >

      {/* Accordion Section */}
      < Accordion
        isOpen={isAccordionOpen}
        onToggle={() => setIsAccordionOpen((prev) => !prev)}
      />
      < Infocarddata />
    </>
  );
};

export default Filterdata;
